module.exports = __webpack_public_path__ + "img/gz.155c49e2.png";